<ngx-loading-bar [color]="'#007bff'" [includeSpinner]="false"></ngx-loading-bar>

<app-header-nav></app-header-nav>

<router-outlet></router-outlet>
